/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Tab, Tabs, Spinner, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./HiringManagerDashboardNew.scss";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import useHiringManagerDashboardNew from "./useHiringManagerDashboardNew";
import CalendarDashboardComponent from "../../../_uiComponents/CalendarDashboardComponent";
import SkillDashboardComponent from "../../../_uiComponents/SkillDashboardComponent";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    allPublishedJobs,
    assignedMentors,
    appliedMentors,
    allJobsLoading,
    companyName,
    skillsListLoading,
    skillsTagsAdded,
    mentorSelectedSkill,
    candidateSelectedSkill,
    suggestedMentorsLoading,
    suggestedMentors,
    suggestedCandidates,
    suggestedCandidatesLoading,
    onEditJobClick,
    onViewJobsClick,
    onViewJobClick,
    onViewMentorsClick,
    onViewMentorsAppliedClick,
    getJobUpdateIndex,
    onViewMentorProfileClick,
    onMentorJobsSkillsChange,
    onCandidatesJobsSkillsChange,
    onViewCandidateProfileClick,
    onMentorSkillUnselectClick,
    onCandidateSkillUnselectClick,
    onViewAllMentorsClick,
    onViewAllCandidatesClick,
    onViewAllMentorsAppliedClick,
  } = useHiringManagerDashboardNew(props);

  return (
    <MainLayout activeMenuItem="home" pageName="Dashboard">
      <div className="mentor-dashboard-new footer-gap position-relative">
        <Container className="d-flex justify-content-between align-items-center">
          <h2 className="text-dark">
            {companyName.user_meta_info &&
              companyName.user_meta_info.company_details &&
              companyName.user_meta_info.company_details.name}
          </h2>
          <div>
            <button
              onClick={() => onEditJobClick(null)}
              className="btn btn-primary"
            >
              Create a new job
            </button>
          </div>
        </Container>
        <div className="hiring-board">
          <div className="container">
            <div className="row mb-3 mx-0">
              <div className="col-md-8 pl-md-0">
                <div className="dashboard-component-container border border-6 h-100 p-3 mt-4">
                  <div className="d-flex align-items-center border-bottom pb-3 justify-content-between">
                    <div className="d-flex w-50 align-items-center">
                      <h4 className="w-50">Hiring Pipeline</h4>
                    </div>
                    <div className="right d-flex align-items-center">
                      <button
                        onClick={onViewJobsClick}
                        className="bg-transparent border-0 text-primary font-weight-medium "
                      >
                        View All
                      </button>
                    </div>
                  </div>
                  <div className="dashboard-table mt-3">
                    <Table
                      borderless
                      responsive
                      className="table-hiring-pipline mt-3"
                    >
                      <thead className=" p-3  border-bottom-0">
                        <tr className="text-nowrap text-center">
                          <th className="font-weight-medium text-left">Jobs</th>
                          <th className="font-weight-medium">Applied</th>
                          <th className="font-weight-medium">Assessment</th>
                          <th className="font-weight-medium">Interview</th>
                          <th className="font-weight-medium">Offer</th>
                          <th className="font-weight-medium">Hired</th>
                          <th className="font-weight-medium">Rejected</th>
                        </tr>
                      </thead>
                      <tbody className="px-4 text-center text-grey-4 text-capitalize">
                        {allJobsLoading ? (
                          <tr>
                            <td colSpan="7">
                              <div className="d-flex justify-content-center align-items-center p-4">
                                <Spinner animation="border" variant="primary" />
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {allPublishedJobs &&
                              Array.isArray(allPublishedJobs) &&
                              allPublishedJobs.map((item) => (
                                <tr>
                                  <td
                                    className="text-left cursor-pointer font-weight-medium"
                                    onClick={() => onViewJobClick(item?.id)}
                                  >
                                    <h4 className="text-dark">{item?.title}</h4>
                                    <p className="text-grey-4">
                                      Total Application:{" "}
                                      {item?.total_candidates}
                                    </p>
                                  </td>
                                  <td>
                                    {getJobUpdateIndex(
                                      item?.candidates_at_different_stages
                                    ) < 1 ? (
                                      <span className="pipeline-label">
                                        &nbsp;
                                      </span>
                                    ) : (
                                      <span
                                        className={`pipeline-label label-blue ${
                                          getJobUpdateIndex(
                                            item?.candidates_at_different_stages
                                          ) > 1
                                            ? "opacity-full"
                                            : ""
                                        }`}
                                      >
                                        {item?.candidates_at_different_stages &&
                                          item.candidates_at_different_stages
                                            .applied}{" "}
                                        Candidates
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {getJobUpdateIndex(
                                      item?.candidates_at_different_stages
                                    ) < 2 ? (
                                      <span className="pipeline-label">
                                        &nbsp;
                                      </span>
                                    ) : (
                                      <span
                                        className={`pipeline-label label-light-green ${
                                          getJobUpdateIndex(
                                            item?.candidates_at_different_stages
                                          ) > 2
                                            ? "opacity-full"
                                            : ""
                                        }`}
                                      >
                                        {item?.candidates_at_different_stages &&
                                          item.candidates_at_different_stages
                                            .assessment}{" "}
                                        Candidates
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {getJobUpdateIndex(
                                      item?.candidates_at_different_stages
                                    ) < 3 ? (
                                      <span className="pipeline-label">
                                        &nbsp;
                                      </span>
                                    ) : (
                                      <span
                                        className={`pipeline-label label-voilet ${
                                          getJobUpdateIndex(
                                            item?.candidates_at_different_stages
                                          ) > 3
                                            ? "opacity-full"
                                            : ""
                                        }`}
                                      >
                                        {item?.candidates_at_different_stages &&
                                          item.candidates_at_different_stages
                                            .interview}{" "}
                                        Candidates
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {getJobUpdateIndex(
                                      item?.candidates_at_different_stages
                                    ) < 4 ? (
                                      <span className="pipeline-label">
                                        &nbsp;
                                      </span>
                                    ) : (
                                      <span
                                        className={`pipeline-label label-yellow ${
                                          getJobUpdateIndex(
                                            item?.candidates_at_different_stages
                                          ) > 4
                                            ? "opacity-full"
                                            : ""
                                        }`}
                                      >
                                        {item?.candidates_at_different_stages &&
                                          item.candidates_at_different_stages
                                            .offer}{" "}
                                        Candidates
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {getJobUpdateIndex(
                                      item?.candidates_at_different_stages
                                    ) < 5 ? (
                                      <span className="pipeline-label">
                                        &nbsp;
                                      </span>
                                    ) : (
                                      <span
                                        className={`pipeline-label label-green ${
                                          getJobUpdateIndex(
                                            item?.candidates_at_different_stages
                                          ) > 5
                                            ? "opacity-full"
                                            : ""
                                        }`}
                                      >
                                        {item?.candidates_at_different_stages &&
                                          item.candidates_at_different_stages
                                            .hired}{" "}
                                        Candidates
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {getJobUpdateIndex(
                                      item?.candidates_at_different_stages
                                    ) < 6 ? (
                                      <span className="pipeline-label">
                                        &nbsp;
                                      </span>
                                    ) : (
                                      <span
                                        className={`pipeline-label label-red ${
                                          getJobUpdateIndex(
                                            item?.candidates_at_different_stages
                                          ) > 6
                                            ? "opacity-full"
                                            : ""
                                        }`}
                                      >
                                        {item?.candidates_at_different_stages &&
                                          item.candidates_at_different_stages
                                            .rejected}{" "}
                                        Candidates
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            {Array.isArray(allPublishedJobs) &&
                            allPublishedJobs &&
                            allPublishedJobs.length === 0 ? (
                              <tr>
                                <td colSpan="7">
                                  <div
                                    className="d-flex align-items-center
                                  justify-content-center flex-column py-4"
                                  >
                                    <img
                                      src="/assets/images/empty-state.svg"
                                      alt="empty"
                                    />
                                    <h4 className="font-weight-bold mb-1 mt-2">
                                      No Jobs Found!
                                    </h4>
                                    <p className="mb-4 fs-smallest">
                                      Create jobs to attract eligible candidates
                                    </p>
                                    <button
                                      onClick={() => onEditJobClick(null)}
                                      className="px-4 border border-primary shadow
                                    text-primary py-1 rounded-lg font-weight-semi"
                                    >
                                      Create job
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ) : null}
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <div className="col-md-4 pr-md-0">
                <div className="dashboard-component-container border border-6 h-100 p-3 mt-4 dashboard-mentor-list">
                  <div className="d-flex align-items-center justify-content-between">
                    <h4>Mentors</h4>
                    <p
                      className="text-nowrap text-primary font-weight-medium cursor-pointer ml-3"
                      onClick={onViewAllMentorsAppliedClick}
                    >
                      View All
                    </p>
                  </div>
                  <Tabs defaultActiveKey="Applied" className="mt-3">
                    <Tab eventKey="Applied" title="Applied">
                      {allJobsLoading ? (
                        <div className="d-flex justify-content-center align-items-center pt-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <ul className="mentor-list">
                          {appliedMentors &&
                            Array.isArray(appliedMentors) &&
                            appliedMentors.map((item) => (
                              <li className="mentor-box bg-grey d-flex align-items-center">
                                <div className="img-box mr-2">
                                  <img
                                    src={
                                      item?.posted_by_details &&
                                      item.posted_by_details?.company_details &&
                                      item.posted_by_details.company_details
                                        ?.logo
                                        ? item?.posted_by_details &&
                                          item.posted_by_details
                                            ?.company_details &&
                                          item.posted_by_details.company_details
                                            ?.logo
                                        : "/assets/images/building-placeholder.png"
                                    }
                                    alt="user img"
                                  />
                                </div>
                                <div className="content flex-grow-1">
                                  <h4
                                    className="mb-0"
                                    onClick={() =>
                                      onViewMentorsAppliedClick(item?.id)
                                    }
                                  >
                                    {item?.title}
                                  </h4>
                                  <p className="text-grey-4 mb-0">
                                    {item?.mentor_job_application_id
                                      ? `Mentor Assigned: ${item?.mentor_name}`
                                      : ` Number of Mentors: ${item?.total_mentors}`}
                                  </p>
                                </div>
                                <button
                                  className="bg-transparent border-0 ml-auto"
                                  onClick={() =>
                                    onViewMentorsAppliedClick(item?.id)
                                  }
                                >
                                  <FontAwesomeIcon icon={faAngleRight} />
                                </button>
                              </li>
                            ))}
                        </ul>
                      )}
                      {Array.isArray(appliedMentors) &&
                      appliedMentors &&
                      appliedMentors.length === 0 ? (
                        <EmptyFeedCard
                          src={"assets/images/empty-state.svg"}
                          message={"No Mentors Found"}
                          btnText="Applied Mentors"
                          link="/all-applied-mentors"
                        />
                      ) : null}
                    </Tab>
                    <Tab eventKey="Assigned" title="Assigned">
                      {allJobsLoading ? (
                        <div className="d-flex justify-content-center align-items-center pt-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <ul className="mentor-list">
                          {assignedMentors &&
                            Array.isArray(assignedMentors) &&
                            assignedMentors.map((item) => (
                              <li
                                className="mentor-box bg-grey d-flex align-items-center"
                                onClick={() =>
                                  onViewMentorsClick(
                                    item.mentor_job_application_id
                                  )
                                }
                              >
                                <div className="img-box mr-2">
                                  <img
                                    src={
                                      item?.posted_by_details &&
                                      item.posted_by_details?.profile_image
                                        ? item?.posted_by_details &&
                                          item.posted_by_details
                                            ?.company_details &&
                                          item.posted_by_details.profile_image
                                        : "/assets/images/user.png"
                                    }
                                    alt="user"
                                    className="rounded-circle cursor-pointer user-image"
                                  />
                                </div>
                                <div className="content flex-grow-1">
                                  <h4 className="mb-0">{item?.mentor_name}</h4>
                                  <p className="text-grey-4">{item?.title}</p>
                                </div>
                                <button className="bg-transparent border-0 ml-auto">
                                  <FontAwesomeIcon icon={faAngleRight} />
                                </button>
                              </li>
                            ))}
                        </ul>
                      )}
                      {Array.isArray(assignedMentors) &&
                      assignedMentors &&
                      assignedMentors.length === 0 ? (
                        <EmptyFeedCard
                          src={"assets/images/empty-state.svg"}
                          message={"No Mentors Assigned"}
                          btnText="Assigned Mentors"
                          link="/all-applied-mentors"
                        />
                      ) : null}
                    </Tab>
                  </Tabs>
                </div>
              </div>

              {/* Calendar Component */}
              <div className="hm-calendar col-md-8 mb-4 pl-md-0">
                <CalendarDashboardComponent />
              </div>

              <div className="col-md-4 mb-4 pr-md-0">
                <div className="dashboard-component-container border border-6 h-100 p-3 mt-4 dashboard-mentor-list">
                  <div className="d-flex align-items-center justify-content-between ">
                    <h4>Connect with Talents</h4>
                  </div>
                  <Tabs defaultActiveKey="Mentors" className="mt-3">
                    <Tab eventKey="Mentors" title="Mentors">
                      {skillsListLoading ? (
                        <div className="d-flex justify-content-center align-items-center w-100">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <div className="mt-3">
                          {skillsListLoading && suggestedMentorsLoading ? (
                            <div className="d-flex justify-content-center align-items-center w-100">
                              <Spinner animation="border" variant="primary" />
                            </div>
                          ) : (
                            <div className="d-flex">
                              <SkillDashboardComponent
                                selectedSkill={mentorSelectedSkill}
                                skillsTagsAdded={skillsTagsAdded}
                                onSkillUnselectClick={
                                  onMentorSkillUnselectClick
                                }
                                onSkillsChange={(e) =>
                                  onMentorJobsSkillsChange(e)
                                }
                              />
                              <p
                                className="text-nowrap text-primary font-weight-medium cursor-pointer ml-3"
                                onClick={onViewAllMentorsClick}
                              >
                                View All
                              </p>
                            </div>
                          )}

                          {suggestedMentorsLoading ? (
                            <div className="d-flex justify-content-center align-items-center w-100">
                              <Spinner animation="border" variant="primary" />
                            </div>
                          ) : suggestedMentors?.results &&
                            Array.isArray(suggestedMentors?.results) &&
                            suggestedMentors.results.length ? (
                            <ul className="mentor-list mukesh">
                              {suggestedMentors?.results &&
                                Array.isArray(suggestedMentors?.results) &&
                                suggestedMentors?.results.map((item) => (
                                  <li
                                    className="mentor-box bg-grey d-flex align-items-center"
                                    onClick={() =>
                                      onViewMentorProfileClick(
                                        item?.user_details &&
                                          item.user_details?.hash_id
                                      )
                                    }
                                    key={item?.id}
                                  >
                                    <div className="img-box mr-4">
                                      <img
                                        src={
                                          item?.user_details &&
                                          item.user_details?.user_meta_info &&
                                          item.user_details.user_meta_info
                                            ?.profile_image == null
                                            ? "/assets/images/user.png"
                                            : item?.user_details &&
                                              item.user_details
                                                ?.user_meta_info &&
                                              item.user_details.user_meta_info
                                                ?.profile_image
                                        }
                                        alt="user img"
                                      />
                                    </div>
                                    <div className="content flex-grow-1">
                                      <h4 className="mb-0">
                                        {item?.user_details &&
                                          item.user_details?.full_name}
                                      </h4>
                                      <div className="d-flex flex-wrap align-items-center mt-2">
                                        {item?.skills &&
                                          Array.isArray(item?.skills) &&
                                          item.skills.map((tag) => (
                                            <>
                                              {tag?.is_primary === true ? (
                                                <div
                                                  className={
                                                    "border rounded-pill text-nowrap text-grey-4 px-2 mr-2 text-capitalize mb-1"
                                                  }
                                                  key={tag?.id}
                                                >
                                                  {tag?.skill_name}
                                                </div>
                                              ) : null}
                                            </>
                                          ))}
                                      </div>
                                    </div>
                                    <button className="bg-transparent border-0 ml-auto">
                                      <FontAwesomeIcon icon={faAngleRight} />
                                    </button>
                                  </li>
                                ))}
                            </ul>
                          ) : (
                            <EmptyFeedCard
                              src={"assets/images/empty-state.svg"}
                              message={"No Mentors Found"}
                              btnText="view Mentors"
                              link="/all-mentors"
                            />
                          )}
                        </div>
                      )}
                    </Tab>
                    <Tab eventKey="Candidates" title="Candidates">
                      {skillsListLoading && suggestedCandidatesLoading ? (
                        <div className="d-flex justify-content-center align-items-center w-100">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <div className="mt-3">
                          {skillsListLoading && suggestedCandidatesLoading ? (
                            <div className="d-flex justify-content-center align-items-center w-100">
                              <Spinner animation="border" variant="primary" />
                            </div>
                          ) : (
                            <div className="d-flex justify-content-between">
                              <SkillDashboardComponent
                                selectedSkill={candidateSelectedSkill}
                                skillsTagsAdded={skillsTagsAdded}
                                onSkillUnselectClick={
                                  onCandidateSkillUnselectClick
                                }
                                onSkillsChange={(e) =>
                                  onCandidatesJobsSkillsChange(e)
                                }
                              />
                              <p
                                className="view-btn text-primary font-weight-medium cursor-pointer ml-3"
                                onClick={onViewAllCandidatesClick}
                              >
                                View All
                              </p>
                            </div>
                          )}

                          {suggestedCandidatesLoading ? (
                            <div className="d-flex justify-content-center align-items-center w-100">
                              <Spinner animation="border" variant="primary" />
                            </div>
                          ) : suggestedCandidates?.results &&
                            Array.isArray(suggestedCandidates?.results) &&
                            suggestedCandidates.results.length ? (
                            <ul className="mentor-list">
                              {suggestedCandidates?.results &&
                                Array.isArray(suggestedCandidates.results) &&
                                suggestedCandidates.results.map((item) => (
                                  <li
                                    className="mentor-box bg-grey d-flex align-items-center"
                                    onClick={() =>
                                      onViewCandidateProfileClick(
                                        item?.user_details &&
                                          item.user_details?.hash_id
                                      )
                                    }
                                    key={item?.id}
                                  >
                                    <div className="img-box mr-4">
                                      <img
                                        src={
                                          item?.user_details &&
                                          item.user_details?.user_meta_info &&
                                          item.user_details.user_meta_info
                                            ?.profile_image === null
                                            ? "/assets/images/user.png"
                                            : item?.user_details &&
                                              item.user_details
                                                ?.user_meta_info &&
                                              item.user_details.user_meta_info
                                                ?.profile_image
                                        }
                                        alt="user img"
                                      />
                                    </div>
                                    <div className="content flex-grow-1">
                                      <h4 className="mb-0">
                                        {item?.user_details &&
                                          item.user_details?.full_name}
                                      </h4>
                                      <div className="d-flex flex-wrap align-items-center mt-2">
                                        {item?.skills &&
                                          Array.isArray(item?.skills) &&
                                          item.skills.map((tag) => (
                                            <>
                                              {tag?.is_primary === true ? (
                                                <div
                                                  className={
                                                    "border rounded-pill text-nowrap text-grey-4 px-2 mr-2 text-capitalize mb-1"
                                                  }
                                                  key={tag?.id}
                                                >
                                                  {tag?.skill_name}
                                                </div>
                                              ) : null}
                                            </>
                                          ))}
                                      </div>
                                    </div>
                                    <button className="bg-transparent border-0 ml-auto">
                                      <FontAwesomeIcon icon={faAngleRight} />
                                    </button>
                                  </li>
                                ))}
                            </ul>
                          ) : (
                            <EmptyFeedCard
                              src={"assets/images/empty-state.svg"}
                              message={"No Candidates Found"}
                              btnText="View Candidates"
                              link="/all-candidates"
                            />
                          )}
                        </div>
                      )}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
